class DropdownBehavior {
    constructor(
        wrapper = '[data-core-nav="header"]',
        selector = '[aria-haspopup="true"]',
        closeOnOutsideClick = true,
        callback = undefined,
        focusNext = true
    ) {
        this._hydrateWrapper(wrapper, selector, closeOnOutsideClick, callback);
        this.focusNext = focusNext;
    }

    _hydrateWrapper(wrapper, selector, closeOnOutsideClick, callback) {
        const containers = document.body.querySelectorAll(wrapper);
        containers.forEach(container => {
            this._hydrateDropdown(container, selector, closeOnOutsideClick, callback);
        });
    }

    _hydrateDropdown(container, selector, closeOnOutsideClick, callback) {
        const buttons = container.querySelectorAll(selector);
        if (buttons.length > 0) {
            const thisWidget = this;
            buttons.forEach(button => {
                const menu = container.querySelector('#' + button.getAttribute('aria-controls'));
                if (!menu) return;
                if (menu.getAttribute('role') === 'menu') {
                    if (jQuery) {
                        jQuery(menu).hide();
                    } else {
                        menu.setAttribute('tabindex', '-1');
                    }
                    button.addEventListener('click', function () {
                        thisWidget._toggle(button, menu);
                        callback && callback(this);
                    });
                }
            });

            if (closeOnOutsideClick) {
                document.body.addEventListener('click', function (event) {
                    const target = event.target;
                    const targetParent = event.target.parentNode;
                    if (!target.hasAttribute('aria-haspopup') && !targetParent.hasAttribute('aria-haspopup')) {
                        thisWidget._clickOutside(target, container);
                    }
                });
            }
        }
    }

    _clickOutside(target, container) {
        const thisWidget = this;
        const triggers = container.querySelectorAll('[aria-haspopup="true"][aria-expanded="true"]');
        let clickedInsideTheMenu = false;
        triggers.forEach(trigger => {
            const menu = trigger.nextElementSibling;
            const parents = [];
            let child = target;
            while (child) {
                if (child === menu) {
                    clickedInsideTheMenu = true;
                    break;
                }
                parents.unshift(child);
                child = child.parentNode;
            }
            if (!clickedInsideTheMenu) {
                thisWidget._hide(trigger, menu);
            }
        });
    }
    _hide(trigger, menu) {
        if (jQuery) {
            jQuery(menu).slideToggle('fast');
        } else {
            menu.setAttribute('tabindex', '-1');
        }
        trigger.setAttribute('aria-expanded', 'false');
    }
    _show(trigger, menu) {
        if (jQuery) {
            jQuery(menu).slideToggle('fast');
        }
        if (this.focusNext) {
            menu.setAttribute('tabindex', '0');
            menu.focus();
        }
        trigger.setAttribute('aria-expanded', 'true');
    }
    _toggle(trigger, menu) {
        const expanded = trigger.getAttribute('aria-expanded');
        if (expanded === 'true') {
            this._hide(trigger, menu);
        } else {
            this._show(trigger, menu);
        }
    }
}

module.exports = DropdownBehavior;
